import { default as PreviewCardTimestamp } from '../../_internal/components/PreviewCardTimestamp';
export default PreviewCardTimestamp;